// ─── Supabase client (browser) ───────────────────────────────────────────────
//
// El front maneja las tablas de Master classes directamente contra Supabase con
// la ANON KEY (pública, segura para el browser). La autorización vive en
// políticas RLS (ver docs/supabase/webinars.sql).
//
// LECTURAS: públicas vía RLS → este cliente anónimo funciona siempre.
// ESCRITURAS (panel admin): NO pasan por este cliente. Van a la Edge Function
// `bright-responder`, que valida admin (vía /decode) y escribe con service-role
// (ignora RLS). Ver src/services/masterClasses/index.js y docs/supabase/webinar-admin.ts.
// Este cliente también sirve de transporte para invocar esa function
// (supabase.functions.invoke).

import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
